import { helpApi } from 'src/api';
import toastrError from 'src/helpers/toastr/toastrError';
import toastrSuccess from 'src/helpers/toastr/toastrSuccess';


export const UPDATE_HELP_LIST_ORDER = 'UPDATE_HELP_LIST_ORDER';

export const CHANGE_HELP_TAB_INDEX = 'CHANGE_HELP_TAB_INDEX';
export const SET_HELP_ITEM_ID = 'SET_HELP_ITEM_ID';
export const RESET_HELP_ITEM_ID = 'RESET_HELP_ITEM_ID';

export const LOAD_HELP_LIST_REQUEST = 'LOAD_HELP_LIST_REQUEST';
export const LOAD_HELP_LIST_SUCCESS = 'LOAD_HELP_LIST_SUCCESS';
export const LOAD_HELP_LIST_FAIL = 'LOAD_HELP_LIST_FAIL';

export const SET_HELP_LIST_ORDER_REQUEST = 'SET_HELP_LIST_ORDER_REQUEST';
export const SET_HELP_LIST_ORDER_SUCCESS = 'SET_HELP_LIST_ORDER_SUCCESS';
export const SET_HELP_LIST_ORDER_FAIL = 'SET_HELP_LIST_ORDER_FAIL';

export const LOAD_HELP_CATEGORIES_REQUEST = 'LOAD_HELP_CATEGORIES_REQUEST';
export const LOAD_HELP_CATEGORIES_SUCCESS = 'LOAD_HELP_CATEGORIES_SUCCESS';
export const LOAD_HELP_CATEGORIES_FAIL = 'LOAD_HELP_CATEGORIES_FAIL';

export const LOAD_HELP_LANGUAGES_REQUEST = 'LOAD_HELP_LANGUAGES_REQUEST';
export const LOAD_HELP_LANGUAGES_SUCCESS = 'LOAD_HELP_LANGUAGES_SUCCESS';
export const LOAD_HELP_LANGUAGES_FAIL = 'LOAD_HELP_LANGUAGES_FAIL';

export const LOAD_HELP_RECORD_REQUEST = 'LOAD_HELP_RECORD_REQUEST';
export const LOAD_HELP_RECORD_SUCCESS = 'LOAD_HELP_RECORD_SUCCESS';
export const LOAD_HELP_RECORD_FAIL = 'LOAD_HELP_RECORD_FAIL';

export const LOAD_HELP_NEWS_REQUEST = 'LOAD_HELP_NEWS_REQUEST';
export const LOAD_HELP_NEWS_SUCCESS = 'LOAD_HELP_NEWS_SUCCESS';
export const LOAD_HELP_NEWS_FAIL = 'LOAD_HELP_NEWS_FAIL';

export const CREATE_HELP_RECORD_REQUEST = 'CREATE_HELP_RECORD_REQUEST';
export const CREATE_HELP_RECORD_SUCCESS = 'CREATE_HELP_RECORD_SUCCESS';
export const CREATE_HELP_RECORD_FAIL = 'CREATE_HELP_RECORD_FAIL';

export const UPDATE_HELP_RECORD_REQUEST = 'UPDATE_HELP_RECORD_REQUEST';
export const UPDATE_HELP_RECORD_SUCCESS = 'UPDATE_HELP_RECORD_SUCCESS';
export const UPDATE_HELP_RECORD_FAIL = 'UPDATE_HELP_RECORD_FAIL';

export const DELETE_HELP_RECORD_REQUEST = 'DELETE_HELP_RECORD_REQUEST';
export const DELETE_HELP_RECORD_SUCCESS = 'DELETE_HELP_RECORD_SUCCESS';
export const DELETE_HELP_RECORD_FAIL = 'DELETE_HELP_RECORD_FAIL';

export const READ_HELP_NEWS_REQUEST = 'READ_HELP_NEWS_REQUEST';
export const READ_HELP_NEWS_SUCCESS = 'READ_HELP_NEWS_SUCCESS';
export const READ_HELP_NEWS_FAIL = 'READ_HELP_NEWS_FAIL';

const updateHelpList = (helpData) => (dispatch) => dispatch({ type: UPDATE_HELP_LIST_ORDER, helpData });

export const changeTabIndex = (tabIndex) => (dispatch) => dispatch({ type: CHANGE_HELP_TAB_INDEX, tabIndex });
export const setHelpItemId = (itemId) => (dispatch) => dispatch({ type: SET_HELP_ITEM_ID, itemId });
export const reSetHelpItemId = () => (dispatch) => dispatch({ type: RESET_HELP_ITEM_ID });

const loadHelpListRequest = (fetching) => ({ type: LOAD_HELP_LIST_REQUEST, fetching });
const loadHelpListSuccess = (helpData) => ({ type: LOAD_HELP_LIST_SUCCESS, helpData });
const loadHelpListFail = (error) => ({ type: LOAD_HELP_LIST_FAIL, error });

const setHelpListOrderRequest = () => ({ type: SET_HELP_LIST_ORDER_REQUEST });
const setHelpListOrderSuccess = () => ({ type: SET_HELP_LIST_ORDER_SUCCESS });
const setHelpListOrderFail = (error) => ({ type: SET_HELP_LIST_ORDER_FAIL, error });

const loadHelpCategoriesRequest = () => ({ type: LOAD_HELP_CATEGORIES_REQUEST });
const loadHelpCategoriesSuccess = (categoriesList) => ({ type: LOAD_HELP_CATEGORIES_SUCCESS, categoriesList });
const loadHelpCategoriesFail = (error) => ({ type: LOAD_HELP_CATEGORIES_FAIL, error });

const loadHelpLanguagesRequest = () => ({ type: LOAD_HELP_LANGUAGES_REQUEST });
const loadHelpLanguagesSuccess = (langList) => ({ type: LOAD_HELP_LANGUAGES_SUCCESS, langList });
const loadHelpLanguagesFail = (error) => ({ type: LOAD_HELP_LANGUAGES_FAIL, error });

const createHelpRecordRequest = () => ({ type: CREATE_HELP_RECORD_REQUEST });
const createHelpRecordSuccess = () => ({ type: CREATE_HELP_RECORD_SUCCESS });
const createHelpRecordFail = () => ({ type: CREATE_HELP_RECORD_FAIL });

const updateHelpRecordRequest = () => ({ type: UPDATE_HELP_RECORD_REQUEST });
const updateHelpRecordSuccess = (helpRecord) => ({ type: UPDATE_HELP_RECORD_SUCCESS, helpRecord });
const updateHelpRecordFail = () => ({ type: UPDATE_HELP_RECORD_FAIL });

const deleteHelpRecordRequest = () => ({ type: DELETE_HELP_RECORD_REQUEST });
const deleteHelpRecordSuccess = () => ({ type: DELETE_HELP_RECORD_SUCCESS });
const deleteHelpRecordFail = () => ({ type: DELETE_HELP_RECORD_FAIL });

const loadHelpRecordRequest = () => ({ type: LOAD_HELP_RECORD_REQUEST });
const loadHelpRecordSuccess = (helpRecord) => ({ type: LOAD_HELP_RECORD_SUCCESS, helpRecord });
const loadHelpRecordFail = () => ({ type: LOAD_HELP_RECORD_FAIL });

const loadHelpNewsRequest = () => ({ type: LOAD_HELP_NEWS_REQUEST });
const loadHelpNewsSuccess = (helpNews) => ({ type: LOAD_HELP_NEWS_SUCCESS, helpNews });
const loadHelpNewsFail = () => ({ type: LOAD_HELP_NEWS_FAIL });

const readHelpNewsRequest = () => ({ type: READ_HELP_NEWS_REQUEST });
const readHelpNewsSuccess = () => ({ type: READ_HELP_NEWS_SUCCESS });
const readHelpNewsFail = () => ({ type: READ_HELP_NEWS_FAIL });

const convertToCategoriesOptions = (categoriesList) => categoriesList.map(({ name, id }) => ({ label: name, value: id }));

const convertToLanguagesOptions = (categoriesList) => categoriesList.map(({ languageCode, id }) => ({ label: languageCode, value: id }));

const getMainList = (list) => list.map(({
  title,
  helpItemId,
  categoryIds
}) => ({
  label: title,
  value: helpItemId,
  categories: categoryIds
}));

export const setListOrder = (data) => (dispatch) => {
  dispatch(setHelpListOrderRequest());
  return helpApi.helpItems.setOrder(data)
    .then((response) => {
      toastrSuccess(response);
      dispatch(setHelpListOrderSuccess());
    }).catch((e) => {
      toastrError(e);
      dispatch(setHelpListOrderFail(e));
    });
};

export const loadHelpCategories = () => (dispatch) => {
  dispatch(loadHelpCategoriesRequest());
  return helpApi.categories.getAll().then(({ data }) => {
    dispatch(loadHelpCategoriesSuccess(convertToCategoriesOptions(data.data)));
  }).catch((e) => {
    toastrError(e);
    dispatch(loadHelpCategoriesFail(e));
  });
};

export const loadHelpLanguages = () => (dispatch) => {
  dispatch(loadHelpLanguagesRequest());
  return helpApi.languages.getAll().then(({ data }) => {
    dispatch(loadHelpLanguagesSuccess(convertToLanguagesOptions(data.data)));
  }).catch((e) => {
    toastrError(e);
    dispatch(loadHelpLanguagesFail(e));
  });
};

export const updateHelpListOrder = (lang, list) => (dispatch) => {
  dispatch(updateHelpList({
    lang,
    list,
    mainList: getMainList(list)
  }));
};

export const loadHelpList = (languageCode, isEktaco = false, fetching = true) => (dispatch) => {
  dispatch(loadHelpNews(languageCode));
  dispatch(loadHelpListRequest(fetching));
  return new Promise((resolve, reject) => {
    (isEktaco ? helpApi.helpItems.getAll({ languageCode }) : helpApi.helpItems.getAllActive({ languageCode }))
      .then(({ data }) => {
        dispatch(loadHelpListSuccess({
          lang: languageCode,
          list: data.data,
          mainList: getMainList(data.data)
        }));
        resolve();
      })
      .catch((e) => {
        toastrError(e);
        dispatch(loadHelpListFail(e));
        reject();
      });
  });
};

export const createHelpRecord = (data, langName, isEktaco = false) => (dispatch) => {
  dispatch(createHelpRecordRequest());
  return helpApi.helpItems.add(data).then((response) => {
    toastrSuccess(response);
    dispatch(createHelpRecordSuccess());
    dispatch(loadHelpList(langName, isEktaco, false))
      .then(dispatch(setHelpItemId(response.data.data)));
  }).catch((e) => {
    toastrError(e);
    dispatch(createHelpRecordFail(e));
  });
};

export const updateHelpRecord = (data, langName, isEktaco = false) => (dispatch) => {
  dispatch(updateHelpRecordRequest());
  return helpApi.helpItems.update(data).then((response) => {
    toastrSuccess(response);
    dispatch(updateHelpRecordSuccess(response.data.data));
    dispatch(loadHelpList(langName, isEktaco, false));
  }).catch((e) => {
    toastrError(e);
    dispatch(updateHelpRecordFail(e));
  });
};

export const deleteHelpRecord = (helpItemId, langName, isEktaco = false) => (dispatch) => {
  dispatch(deleteHelpRecordRequest());
  return helpApi.helpItems.delete({ helpItemId }).then((response) => {
    toastrSuccess(response);
    dispatch(deleteHelpRecordSuccess(response.data.Data));
    dispatch(reSetHelpItemId());
    dispatch(loadHelpList(langName, isEktaco, false));
  }).catch((e) => {
    toastrError(e);
    dispatch(deleteHelpRecordFail(e));
  });
};

export const loadHelpRecord = (id, languageCode, isEktaco = false) => (dispatch) => {
  dispatch(loadHelpRecordRequest());
  return (isEktaco ? helpApi.helpItems.get(id) : helpApi.helpItems.getActive(id)).then(({ data }) => {
    dispatch(loadHelpRecordSuccess(data.data));
    if (!data.data.isRead) {
      dispatch(readHelpNews([id], languageCode, isEktaco));
    }
  }).catch((e) => {
    toastrError(e);
    dispatch(loadHelpRecordFail(e));
  });
};

export const loadHelpNews = (languageCode) => (dispatch) => {
  dispatch(loadHelpNewsRequest());
  return helpApi.notifications.getNewNotifications({ languageCode })
    .then(({ data }) => {
      dispatch(loadHelpNewsSuccess({
        lang: languageCode,
        list: data.data
      }));
    }).catch((e) => {
      toastrError(e);
      dispatch(loadHelpNewsFail(e));
    });
};

export const readHelpNews = (ids, languageCode, isEktaco = false) => (dispatch) => {
  dispatch(readHelpNewsRequest());
  return helpApi.helpItems.markAsRead({ ids }).then(() => {
    dispatch(readHelpNewsSuccess());
    dispatch(loadHelpList(languageCode, isEktaco, false));
  }).catch((e) => {
    toastrError(e);
    dispatch(readHelpNewsFail(e));
  });
};
